import(/* webpackMode: "eager" */ "/home/runner/work/baldr/baldr/src/app/[slug]/(auth)/auth/page.tsx");
